const baseClass = "rj-superbanner";
function toUpperCase(str) {
    return str.toUpperCase();
}
function getSideArrowWrapper(scrollability) {
    return scrollability.left || scrollability.right ? " rj-side-arrow__block-wrapper" : "";
}
function getBannerModifier(props) {
    let mod = props.side.replace(/^(.)/g, toUpperCase);
    return props.scrollability[props.side] ? ` ${baseClass}--s${mod}` : "";
}
function getBannerModeModifier(props) {
    return !props.isMultipleItemsModeEnabled ? ` ${baseClass}--desktop-full-view` : "";
}
function getBannerDragModifier(draggable) {
    return draggable ? ` ${baseClass}--draggable` : "";
}
function getMobileModeModifier(props) {
    return props.isMobileMode ? ` ${baseClass}--mobile-small-view` : "";
}
export function getBannerClasses(props) {
    let leftProps = Object.assign(Object.assign({}, props), { side: "left" });
    let rightProps = Object.assign(Object.assign({}, props), { side: "right" });
    return `${baseClass}${getBannerModeModifier(props)}` +
        `${getSideArrowWrapper(props.scrollability)}${getBannerModifier(leftProps)}${getBannerModifier(rightProps)}` +
        `${getBannerDragModifier(props.draggability)}${getMobileModeModifier(props)}`;
}
//# sourceMappingURL=GetBannerClasses.js.map